// src/components/Intro/Intro.jsx
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

import slide1 from "../../assets/empty_stage.webp";
import slide2 from "../../assets/joyride_lava.webp";
import slide3 from "../../assets/joyride_live1.webp";
import slide4 from "../../assets/joyride_rummut.webp";
import slide5 from "../../assets/joyride_live3.webp";
import slide6 from "../../assets/bilebandi_joyride_harman_rati.png";

import logo from "../../assets/logo_500x500px_ei_harsoa.webp";

const slides = [
  {
    image: slide1,
    alt: "Bilebändin Joyriden basisti esiintyy lavalla violetissa valossa"
  },
  {
    image: slide2,
    alt: "Bilebändi Joyride esiintymässä juhlavalaistuksella"
  },
  {
    image: slide3,
    alt: "Kitaristi lavalla yleisön edessä"
  },
  {
    image: slide4,
    alt: "Rumpalin setti takaviistosta valaistuna savussa"
  },
  {
    image: slide5,
    alt: "Rumpalin setti takaviistosta valaistuna savussa"
  },
   {
    image: slide6,
    alt: "Rumpalin setti takaviistosta valaistuna savussa"
  },

];

const testimonials = [
  "''Bilebändi Joyride toi erittäin hyvää tunnelmaa meidän yrityksemme pikkujouluihin. Tunnelma oli katossa ja bändi loistava.''",
  "''Kiitos teille mahtavasta tunnelmasta ja hyvästä meiningistä! Alusta asti viestiminen ja asioista sopiminen oli helppoa. Myös vieraat kehui seuraavana aamuna miten hyvä asenne teillä oli ja kaikki meni hyvin!''",
  "''Olitte enemmän kuin uskalsin toivoa! Erinomaisesti saitte yleisön mukaan ja loitte hyvän biletunnelman. Kanssanne oli helppo sopia asioista.''",
  "''Kiitos mahtavasta esiintymisestänne hääjuhlassamme! Kaikki meni tosi hienosti ja olimme todella tyytyväisiä''",
  "''Hyvän keikan soittivat häissämme. Hyväntuulinen ja osaava bändi. Kannattaa valita tämä bändi juhliin. Kivasti heidän kanssaan soittolista sovittavissa.''",
    "''Kiitos huikeasta hääkeikasta! Tunnelma oli katossa ja tanssilattia täynnä, Joyride rokkasi!!''",
];

const Intro = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 2000, easing: "ease-out-cubic" });
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative h-screen overflow-hidden">

      {/* Taustakuvat */}
      {slides.map((slide, idx) => (
   <motion.div
  key={idx}
  className="absolute inset-0"
  initial={{ opacity: 0, scale: 1 }}
  animate={idx === currentSlide
    ? { opacity: 1, scale: 1.1 }
    : { opacity: 0, scale: 1 }
  }
  transition={{
    opacity: { duration: 1 },
    scale:   { duration: 7, ease: "easeOut" }
  }}
>
  <img
    src={slide.image}
    alt={slide.alt}
    className="w-full h-full object-cover"
    loading={idx === 0 ? "eager" : "lazy"}
    width="1920"
    height="1080"
  />
  {/* 1) Gradient-­peitto pohjasta ylöspäin */}
  <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-transparent to-transparent pointer-events-none bg-black bg-opacity-55" />
  {/* 2) Kevyt blur kerroksen päällä */}
  <div className="absolute inset-0 pointer-events-none" />
</motion.div>

    ))}

    {/* Logo */}
    <div className="absolute inset-x-0 top-2/4 md:top-1/2 lg:top-1/3 xl:top-1/4 flex justify-center z-20 pointer-events-none">
      <motion.img
        src={logo}
        alt="Bilebändi Joyride logo"
        width="500"
        height="500"
        fetchpriority="high"
        loading="eager"
        className="w-96 md:w-3/6 drop-shadow-2xl"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      />
    </div>

      {/* Palautteet */}
      <AnimatePresence mode="wait">
        <motion.div
          key={currentSlide}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 50 }}
          transition={{ duration: 0.8 }}
          className="absolute top-16 right-6 md:top-16 md:right-16 z-30 flex flex-col items-end space-y-2"
        >
         <motion.h3
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-white text-lg md:text-xl font-lobster drop-shadow-lg dark:text-shadow-lg"
          >
            Asiakkaiden palautteita
          </motion.h3>

          <div
            className="bg-white bg-opacity-65 dark:bg-black dark:bg-opacity-60
              px-4 py-3 rounded-lg shadow-lg transform -rotate-2
              w-48 md:max-w-sm lg:max-w-md"
          >
            <p className="italic text-left text-xs md:text-sm lg:text-base xl:text-lg text-gray-900 dark:text-gray-100">
              {testimonials[currentSlide]}
            </p>
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Some-ikonit */}
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="absolute left-7 top-24 transform -translate-y-1/2 z-30 flex flex-col space-y-4 items-center"
      >
        <a
          href="https://www.facebook.com/bilebandijoyride"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          className="hover:text-joyrideCyan hover:scale-110 transition transform"
        >
          <FaFacebookF size={30} className="text-white" />
        </a>
        <a
          href="https://www.instagram.com/bilebandijoyride/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="hover:text-joyrideCyan hover:scale-110 transition transform"
        >
          <FaInstagram size={30} className="text-white" />
        </a>
        <a
          href="https://www.tiktok.com/@bilebandijoyride"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="TikTok"
          className="hover:text-joyrideCyan hover:scale-110 transition transform"
        >
          <FaTiktok size={30} className="text-white" />
        </a>
      </motion.div>
    </div>
  );
};

export default Intro;
